module.exports = __webpack_public_path__ + "assets/img/262b-is.svg";